import React from 'react';
import styled from 'styled-components';

// Styled component for skip links
const SkipLinksContainer = styled.div`
  position: absolute;
  top: -1000px;
  left: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
  z-index: 9999;

  a {
    background-color: #3377C6;
    border-right: 1px solid #fff;
    color: #fff;
    font-weight: 600;
    left: 0;
    padding: 10px 15px;
    position: absolute;
    text-decoration: none;
    transition: top 0.3s ease;
    top: -100px;
    
    &:focus {
      background-color: #3377C6;
      box-shadow: 0 0 0 2px rgba(51, 119, 198, 0.5);
      outline: none;
      position: fixed;
      top: 0;
      left: 0;
      height: auto;
      width: auto;
      overflow: auto;
      z-index: 9999;
    }
  }
`;

/**
 * SkipLinks component provides keyboard users with links to skip to main content areas
 * This improves accessibility by allowing users to bypass repetitive navigation elements
 */
const SkipLinks = () => {
  return (
    <SkipLinksContainer>
      <a href="#main-content">Skip to main content</a>
      <a href="#main-navigation">Skip to main navigation</a>
      <a href="#footer">Skip to footer</a>
    </SkipLinksContainer>
  );
};

export default SkipLinks; 